import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import SettingsComponent from "./SettingsComponent";
import AuthorizationWrapper from "../common/authorization/AuthorizationWrapper";
import PartnerSynchronizationListBrowser from "features/partnerSynchronization/components/PartnerSynchronizationListBrowser";
import { APP_VERSION_QUERY, DATABASE_VERSION_QUERY } from "./queries";
import { RESET_CACHE } from "./mutations";
import { INVALIDATE_GLOBAL_PARAMS } from "features/params/globalParams/actionTypes";
import * as rightsCodes from "constants/rightsCodes";
import { useDispatch } from "react-redux";
import { useSimpleError } from "hooks/apolloWrappers";
import { showInfo } from "actions/actionCreators/snackbarActions";
import { useVersion } from "./hooks/useVersion";
import { useTranslation } from "react-i18next";
import * as types from "actions/eventTypes";

const SettingsContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [disabled, setDisabled] = useState(false);
  const appVersion = useVersion(APP_VERSION_QUERY);
  const databaseVersion = useVersion(DATABASE_VERSION_QUERY);
  const showError = useSimpleError();

  const [resetCache] = useMutation(RESET_CACHE, {
    onError: error => {
      showError(error);
      setDisabled(false);
    },
    onCompleted: _ => {
      setDisabled(false);
      dispatch(showInfo(t("Notifications." + types.CACHE_RESET)));
      dispatch({ type: INVALIDATE_GLOBAL_PARAMS });
    }
  });

  const handleResetCache = async () => {
    setDisabled(true);
    resetCache({ variables: {} });
  };

  return (
    <AuthorizationWrapper code={rightsCodes.MASTER_PARTNER_MENU_SETTINGS}>
      <SettingsComponent
        appVersion={appVersion}
        databaseVersion={databaseVersion}
        onResetCache={handleResetCache}
        disabled={disabled}
      />
      <AuthorizationWrapper code={rightsCodes.MASTER_PARTNER_SYNCHRONIZATION_HISTORY}>
        <PartnerSynchronizationListBrowser />
      </AuthorizationWrapper>
    </AuthorizationWrapper>
  );
};

SettingsContainer.propTypes = {};

export default SettingsContainer;
